import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const STransferDetailsPageContentTable = styled.div`
  ${setFlexDFFDC};
`;
